import { useLayoutEffect, useRef, RefObject } from 'react';
import type { DataGridHandle } from 'components/DataGrid';
import type { GridSummaryRow, RowOrGroup } from '../../types';
import type { Column } from 'components/DataGrid';
import { getCell } from 'components/DataGrid/utils';

export function useFocusInvalid(
  gridRef: RefObject<DataGridHandle>,
  rows: RowOrGroup[],
  columns: Column<RowOrGroup, GridSummaryRow>[],
) {
  const focusInvalidRef = useRef(false);

  useLayoutEffect(() => {
    if (focusInvalidRef.current) {
      focusInvalidRef.current = false;

      for (let rowIdx = 0; rowIdx < rows.length; rowIdx++) {
        const row = rows[rowIdx];
        if (row._isGroup) {
          continue;
        }

        for (let idx = 0; idx < columns.length; idx++) {
          if (getCell(columns[idx], row).state.valid === false) {
            gridRef.current?.selectCell({ rowIdx, idx });
            return;
          }
        }
      }
    }
  }, [rows, columns, gridRef]);

  return () => {
    focusInvalidRef.current = true;
  };
}
